import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Form } from '@anytag/shared-atoms';
import { PostsPrice } from '../../shared';
import { TalentInfluencerFormValues } from '../schema-types';

export const PostsPriceSection = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext<TalentInfluencerFormValues>();
  const influencerId = watch('id');

  return (
    <>
      <Form.SectionTitle className="mt-3 mb-0" label={t('post price')} />
      <PostsPrice influencerId={influencerId} />
    </>
  );
};
